/**
 * Google reCAPTCHA v2 site key for SPA widgets.
 *
 * Set REACT_APP_RECAPTCHA_SITE_KEY in gitignored .env.local / .env.production.local.
 * Server secret: OpenBao pack Candor-test-api → RECAPTCHA_SECRET_KEY.
 */

/** @returns {string} Active site key (empty when not configured). */
export function resolveRecaptchaSiteKey() {
  return String(process.env.REACT_APP_RECAPTCHA_SITE_KEY || '').trim();
}

export default {
  resolveRecaptchaSiteKey,
};
